var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-redirect.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { XSnackbar } from "@adornis/chemistry/elements/components/x-snackbar.js";
import "@adornis/data-view/client/x-data-view.js";
import { View } from "@adornis/data-view/db/view.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { AdornisFilter } from "@adornis/filter/AdornisFilter.js";
import { FormController } from "@adornis/forms/x-form-controller.js";
import "@adornis/forms/x-input.js";
import "@adornis/popover/x-dropdown-selection.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { filter, firstValueFrom, timer } from "rxjs";
import { subscribeRedirectsPaginatedFiltered } from "../api/subscribeRedirectsPaginatedAndFiltered.js";
import { Redirect } from "../db/Redirect.js";
import { docs } from "./docs.js";
import { urlTester } from "./UrlTester.js";
var XRedirect = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.filter = new RXController(this, new AdornisFilter({}));
    this._newRedirect = new RXController(this, void 0);
    this._newRedirectController = new FormController(
      this,
      this._newRedirect.observable.pipe(filter(Boolean)),
      {
        success: async (instance) => {
          XDialog.waitFor(Promise.all([instance.create(), firstValueFrom(timer(1e3))])).then(() => {
            XSnackbar.show("Erfolgreich angelegt!");
            this._newRedirect.next(void 0);
          });
        },
        error: (error) => {
          XSnackbar.show(`Bitte f\xFClle alle Pflichtfelder aus.`);
        }
      }
    );
    this._search = "";
  }
  render() {
    return html`
      <x-flex space="lg"> ${this._info()} ${urlTester.render()} ${this._addRedirect()} ${this._items()} </x-flex>
    `;
  }
  _addRedirect() {
    if (!this._newRedirect.value)
      return html`
        <x-button ${css({ marginLeft: "auto" })} @click=${() => this._newRedirect.next(new Redirect({}))}>
          Neuen Redirect anlegen
        </x-button>
      `;
    return html`
      <x-flex space="md">
        <x-input placeholder="Alte URL" ${this._newRedirectController.field("from")}></x-input>
        <x-input placeholder="Neue URL" ${this._newRedirectController.field("to")}></x-input>
        <x-dropdown-selection
          placeholder="Kategorie"
          .selectables=${[301, 302]}
          .renderString=${(item) => ({ 301: "Permanent", 302: "Tempor\xE4r" })[item] ?? ""}
          ${this._newRedirectController.field("type")}
        ></x-dropdown-selection>
        <x-flex horizontal crossaxis-center space-between space="md" wrap>
          <x-button
            mode="outline"
            @click=${() => {
      this._newRedirect.next(void 0);
    }}
          >
            Abbrechen
          </x-button>
          <x-button
            @click=${() => {
      this._newRedirectController.validate();
    }}
          >
            Speichern
          </x-button>
        </x-flex>
      </x-flex>
    `;
  }
  _items() {
    return html`
      <x-input
        placeholder="Suche..."
        .value=${this._search}
        @value-changed=${(e) => {
      this._search = e.detail.value;
    }}
        @blur=${() => {
      this.filter.next(new AdornisFilter({ ...this.filter.value.toObject(), search: this._search }));
    }}
        @keydown=${(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.filter.next(new AdornisFilter({ ...this.filter.value.toObject(), search: this._search }));
      }
    }}
      ></x-input>
      <x-data-view
        .options=${{
      class: Redirect,
      // @ts-expect-error doesn't matter if the observable return a prosemise or the result in this situation.
      operation: subscribeRedirectsPaginatedFiltered,
      view: new View({
        filter: this.filter.value
      }),
      emptyState() {
        return html`
              <x-flex
                w100
                padding="sm"
                ${css({ width: "100%", padding: "8px", background: "#333", color: "#fff", gridColumn: "1 / 999" })}
                center
                crossaxis-center
              >
                <x-text> Keine Redirects vorhanden </x-text>
              </x-flex>
            `;
      },
      isEntryClickable: false,
      selectionSet: {
        _id: 1,
        _class: 1,
        type: 1,
        from: 1,
        to: 1
      },
      customColumns: [
        {
          fieldName: "from",
          columnName: "Alte URL",
          renderItem: (item) => {
            if (this._editItemID === item._id)
              return html`
                    <x-input
                      placeholder="Alte URL"
                      .value=${item.from}
                      @value-changed=${(e) => {
                item.from = e.detail.value;
              }}
                    ></x-input>
                  `;
            return html` <x-text> ${item.from} </x-text> `;
          }
        },
        {
          fieldName: "to",
          columnName: "Neue URL",
          renderItem: (item) => {
            if (this._editItemID === item._id)
              return html`
                    <x-input
                      placeholder="Neue URL"
                      .value=${item.to}
                      @value-changed=${(e) => {
                item.to = e.detail.value;
              }}
                    ></x-input>
                  `;
            return html` <x-text> ${item.to} </x-text> `;
          }
        },
        {
          fieldName: "type",
          columnName: "Kategorie",
          renderItem: (item) => {
            if (this._editItemID === item._id)
              return html`
                    <x-dropdown-selection
                      placeholder="Kategorie"
                      .selectables=${[301, 302]}
                      .renderString=${(type) => this._translateType(type) ?? ""}
                      .value=${item.type}
                      @value-picked=${(e) => {
                item.type = e.detail.value;
              }}
                    ></x-dropdown-selection>
                  `;
            return html` <x-text> ${this._translateType(item.type)} </x-text> `;
          }
        },
        {
          customID: "actions",
          columnName: "",
          columnWidth: "max-content",
          renderItem: (item) => {
            if (this._newRedirect.value || this._editItemID && this._editItemID !== item._id)
              return nothing;
            if (this._editItemID === item._id)
              return html`
                    <x-flex space="xxs" horizontal>
                      ${this.itemIcon({
                icon: this.configuration.icons.cancel,
                action: async () => {
                  item.revert();
                  this._editItemID = void 0;
                }
              })}
                      ${this.itemIcon({
                icon: this.configuration.icons.save,
                action: async () => {
                  XDialog.waitFor(Promise.all([item.save(), firstValueFrom(timer(1e3))])).then(() => {
                    XSnackbar.show("Gespeichert!");
                    this._editItemID = void 0;
                  });
                }
              })}
                    </x-flex>
                  `;
            return html`
                  <x-flex space="xxs" horizontal>
                    ${this.itemIcon({
              icon: this.configuration.icons.edit,
              action: async () => {
                this._editItemID = item._id;
              }
            })}
                    ${this.itemIcon({
              icon: this.configuration.icons.delete,
              action: async () => {
                if (!await XDialog.confirm("Willst du diese Weiterleitung wirklich l\xF6schen?"))
                  return;
                item.remove();
              },
              additionalStyling: { color: this.colors.tone.error }
            })}
                  </x-flex>
                `;
          }
        }
      ]
    }}
        ${css({ overflowY: "auto" })}
      ></x-data-view>
    `;
  }
  _translateType(type) {
    return { 301: "Permanent", 302: "Tempor\xE4r" }[type];
  }
  _info() {
    return html`
      <x-accordeon
        .items=${[
      {
        title: "URLPattern Dokumentation",
        text: () => html` ${docs()} `
      }
    ]}
      ></x-accordeon>
    `;
  }
  itemIcon({
    icon,
    action,
    additionalStyling
  }) {
    return html`
      <x-icon
        @click=${action}
        ${css({
      padding: "8px",
      borderRadius: "4px",
      background: "rgb(220, 220, 220)",
      color: "#333",
      cursor: "pointer",
      ...additionalStyling ?? {}
    })}
      >
        ${icon}
      </x-icon>
    `;
  }
  get configuration() {
    return {
      icons: {
        edit: "edit",
        delete: "delete",
        save: "save",
        cancel: "close"
      }
    };
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {}
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XRedirect.prototype, "filter", 2);
__decorateClass([
  state()
], XRedirect.prototype, "_newRedirect", 2);
__decorateClass([
  state()
], XRedirect.prototype, "_newRedirectController", 2);
__decorateClass([
  state()
], XRedirect.prototype, "_editItemID", 2);
__decorateClass([
  state()
], XRedirect.prototype, "_search", 2);
XRedirect = __decorateClass([
  customElement("x-redirect")
], XRedirect);
export {
  XRedirect
};
